import { useMemo } from "react"
import { useRouteStore } from "@/features/route/state/RouteStore.jsx"
import { selectTreeVessels } from "@/features/route/state/RouteSelectors.jsx"

// Name-sorted vessel rows for the pickers (voyage planner, RNW analyser,
// route import), read from the RouteStore that useVesselsLoader fills.
export default function useVesselOptions() {
  const { state } = useRouteStore()
  const vesselIds = state?.relations?.vesselIds
  const vesselsById = state?.entities?.vesselsById
  // vesselIds is rebuilt on every merge — key on its content instead.
  const vesselIdsKey = (vesselIds ?? []).join(",")
  return useMemo(
    () => selectTreeVessels({ relations: { vesselIds }, entities: { vesselsById } }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vesselIdsKey, vesselsById],
  )
}
